import { Component, HostListener, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { CdkTableVirtualScrollDataSource } from 'ng-table-virtual-scroll';
import { CdkTable } from '@angular/cdk/table';
import { TableColmuns } from 'src/app/interface/TableColumnsinterface';
import { Subscription } from 'rxjs';
import { PlanificadorService } from '../models/control.service';
import { rendimientoanualinterface } from 'src/app/interface/RendimientoAnualInterface';
import { DiversificadorService } from 'src/app/services/diversificador.services';
import { GestionService } from 'src/app/services/gestion.services';
import { BrokerService } from 'src/app/services/broker.services';
import { tablainterface } from 'src/app/interface/TablaInterface';


@Component({
  selector: 'app-rendimientoriesgo',
  templateUrl: './rendimientoriesgo.component.html',
  styleUrl: './rendimientoriesgo.component.scss'
})
export class RendimientoriesgoComponent implements OnInit, OnDestroy, OnChanges {

  public combineData: any[]=[];
  public riesgosubscritpion = new Subscription;
  public rentabilidadSub = new Subscription;
  public renAnualSub = new Subscription;
  public rentabilidad: any;
  public rendAnual: CdkTableVirtualScrollDataSource<rendimientoanualinterface[]>;
  public riesgo: any;
  /* DIVERSIFICADOR */
  public divRiesgosubscritpion = new Subscription;
  public divRendimientoSub = new Subscription;
  public divRenAnualSub = new Subscription;
  public divRendimiento: any;
  public divRendAnual: CdkTableVirtualScrollDataSource<rendimientoanualinterface[]>;
  public divRiesgo: any;
  // GESTOR
  public gestRiesgosubscritpion = new Subscription;
  public gestRentabilidadSub = new Subscription;
  public gestRenAnualSub = new Subscription;
  public gestRentabilidad: any;
  public gestRendAnual: CdkTableVirtualScrollDataSource<rendimientoanualinterface[]>;
  public gestRiesgo: any;
  // BROKER
  public brokRiesgosubscritpion = new Subscription;
  public brokRentabilidadSub = new Subscription;
  public brokRenAnualSub = new Subscription;
  public brokRentabilidad: any;
  public brokRendAnual: CdkTableVirtualScrollDataSource<rendimientoanualinterface[]>;
  public brokRiesgo: any;

  // sort state for rendimiento anual tables
  public sortColumnRend: string = 'annio';
  public sortDirectionRend: 'asc' | 'desc' = 'desc';
  private rendAnualRaw: any[] = [];
  private divRendAnualRaw: any[] = [];
  private gestRendAnualRaw: any[] = [];
  private brokRendAnualRaw: any[] = [];

  private readonly defaultRentabilidad: tablainterface[] = [
    { nombre: 'Intervalos operativa', dato: 0 },
    { nombre: 'Beneficio neto', dato: 0 },
    { nombre: 'Beneficio neto %', dato: 0 },
    { nombre: 'Acumulado anual %', dato: 0 },
    { nombre: 'Tasa anual compuesta %', dato: 0 },
    { nombre: 'Numero de operaciones', dato: 0 },
  ];

  private readonly defaultRiesgo: tablainterface[] = [
    { nombre: 'Retroceso maximo %', dato: 0 },
    { nombre: 'Retroceso maximo % diario', dato: 0 },
    { nombre: 'Volatilidad del Intervalo', dato: 0 },
    { nombre: 'Volatilidad anual', dato: 0 },
    { nombre: 'Intervalos sin maximos', dato: 0 },
  ];

  //chartOptions: any;
  
  @Input() selectedTab: number =0;
  @Input() loading: boolean = false;
  @Input() modelo: boolean = false;
  @Input() isPlanificador: boolean = false;
  @Input() isGestion: boolean = false;
  @Input() isBroker: boolean = false;

  @ViewChild(CdkVirtualScrollViewport, { static: false })  viewportRednAnual!: CdkVirtualScrollViewport;
  resizing = false;
  @HostListener('document:mouseup') onMouseUp() {
    this.resizing = false;
  }
  //importaciones para la grafica

  //qui termina


   tableColumns : TableColmuns []=[
    {id: 'nombre', name:'Nombre', isShow: true, isDate: false, isNumber: false, isString: true},
    {id: 'dato', name:'Dato', isShow: true, isDate: false, isNumber: true, isString: false},
   ]

   displayedColumns: string[] = ['nombre','dato'];

   tableColumnsRend : TableColmuns []=[
    {id: 'id', name:'id', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'idcartera', name:'idcartera', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'annio', name:'Año', isShow: true, isDate: false, isNumber: false, isString: true},
    {id: 'rendimiento', name:'Beneficio', isShow: true, isDate: false, isNumber: true, isString: false},
    {id: 'porcentajerendimiento', name:'Beneficio %', isShow: true, isDate: false, isNumber: true, isString: false},
    {id: 'valorliquidativo', name:'valor Liquidativo', isShow: true, isDate: false, isNumber: true, isString: false},
   ]

   displayedColumnsRend: string[] = ['annio','porcentajerendimiento','rendimiento','valorliquidativo'];

   constructor (
    private _controlService: PlanificadorService,
    private _diversificadorsv: DiversificadorService,
    private _gestorsv: GestionService,
    private _brokersv: BrokerService
   ){
    this.rendAnual = new CdkTableVirtualScrollDataSource<rendimientoanualinterface[]>([]);
    this.divRendAnual = new CdkTableVirtualScrollDataSource<rendimientoanualinterface[]>([]);
    this.gestRendAnual=new CdkTableVirtualScrollDataSource<rendimientoanualinterface[]>([]);
    this.brokRendAnual=new CdkTableVirtualScrollDataSource<rendimientoanualinterface[]>([]);
   }

   ngOnInit(): void {
      this.valoresPlanificador();
     this.valoresDiversificador();
     this.valoresGestor();
     this.valoresBroker();
   }

   flattenArray(arrayOfArrays: any[]): any[] {
    return arrayOfArrays.flatMap(innerArray => innerArray);
  }

  sortRendAnual(columnId: string): void {
    if (this.sortColumnRend === columnId) {
      this.sortDirectionRend = this.sortDirectionRend === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumnRend = columnId;
      this.sortDirectionRend = 'asc';
    }
    this.rendAnual.data = this.applyRendSort(this.rendAnualRaw);
    this.divRendAnual.data = this.applyRendSort(this.divRendAnualRaw);
    this.gestRendAnual.data = this.applyRendSort(this.gestRendAnualRaw);
    this.brokRendAnual.data = this.applyRendSort(this.brokRendAnualRaw);
  }

  private applyRendSort(data: any[]): any[] {
    return [...data].sort((a, b) => {
      const valA = a[this.sortColumnRend];
      const valB = b[this.sortColumnRend];
      const cmp = valA < valB ? -1 : valA > valB ? 1 : 0;
      return this.sortDirectionRend === 'asc' ? cmp : -cmp;
    });
  }

   ngOnChanges(changes: SimpleChanges): void {
    if(this.selectedTab === 3){
      this.actualizarViewport();
    } 
   }

  

   startResizingY(event: MouseEvent, column: HTMLElement) {
    // Verificar si el elemento objetivo es el div deseado
    if (column.tagName === 'DIV') {
      const initialY = event.clientY;
      const initialHeigt = column.offsetHeight;
      const mouseMoveListener = (mouseEvent: MouseEvent) => {
        const heightDifference = mouseEvent.clientY - initialY;
        const height = initialHeigt + heightDifference;
        column.style.height = height + 'px';
        if(column.id === 'fila1'){
          const wrapper = column.querySelector('.wrapper') as HTMLElement;
          const initialWrapperHeight = wrapper.offsetHeight;
         // console.log(initialWrapperHeight);
         // wrapper.style.height = (initialWrapperHeight + heightDifference) + 'px';
         wrapper.style.height = height +'px';
        }else if(column.id === 'fila2'){
          const wrapper = column.querySelector('.wrapper2') as HTMLElement;
          const initialWrapperHeight = wrapper.offsetHeight;
        //  wrapper.style.height = (initialWrapperHeight + heightDifference) + 'px';
        wrapper.style.height = height +'px';
        }
        
      };

      const mouseUpListener = () => {
        document.removeEventListener('mousemove', mouseMoveListener);
        document.removeEventListener('mouseup', mouseUpListener);
      };

      document.addEventListener('mousemove', mouseMoveListener);
      document.addEventListener('mouseup', mouseUpListener);
    }
  }

  startResizing2(event: MouseEvent, column: HTMLElement) {

    if (column.tagName === 'DIV') {

        const distanceFromRightEdge = column.offsetWidth - (event.clientX - column.getBoundingClientRect().left);
        const threshold = 50;

        if (distanceFromRightEdge <= threshold) {
          column.style.cursor = 'col-resize';
            const initialX = event.clientX;
            const initialWidth = column.offsetWidth;

            const mouseMoveListener = (mouseEvent: MouseEvent) => {
                const width = initialWidth + (mouseEvent.clientX - initialX);
                column.style.width = width + 'px';
            };

            const mouseUpListener = () => {
              column.style.cursor = 'default';
                document.removeEventListener('mousemove', mouseMoveListener);
                document.removeEventListener('mouseup', mouseUpListener);
            };

            document.addEventListener('mousemove', mouseMoveListener);
            document.addEventListener('mouseup', mouseUpListener);
        }
    }
}


   ngOnDestroy(): void {
     this.riesgosubscritpion.unsubscribe();
     this.rentabilidadSub.unsubscribe();
     this.renAnualSub.unsubscribe();
     this.divRiesgosubscritpion.unsubscribe();
     this.divRendimientoSub.unsubscribe();
     this.divRenAnualSub.unsubscribe();
     this.brokRiesgosubscritpion.unsubscribe();
     this.brokRentabilidadSub.unsubscribe();
     this.brokRenAnualSub.unsubscribe();
     this.gestRiesgosubscritpion.unsubscribe();
     this.gestRentabilidadSub.unsubscribe();
     this.gestRenAnualSub.unsubscribe();
   }

   actualizarViewport() {

    if (this.viewportRednAnual) {
      this.viewportRednAnual.checkViewportSize();
      this.viewportRednAnual.checkViewportSize();
    }
  }

  valoresDiversificador(){
    this.divRendimientoSub = this._diversificadorsv.valDivRentabilidad$.subscribe({
      next: (data: any)=>{
        const flattened = this.flattenArray(data);
        this.divRendimiento = flattened.length ? flattened : this.defaultRentabilidad;
      }
     });
     this.divRiesgosubscritpion = this._diversificadorsv.valDivRiesgo$.subscribe({
      next: (data: any)=>{
        const flattened = this.flattenArray(data);
        this.divRiesgo = flattened.length ? flattened : this.defaultRiesgo;
      }
     });
     this.divRenAnualSub = this._diversificadorsv.valDivRendAnual$.subscribe({
      next: (data: any)=>{
        this.divRendAnualRaw = this.flattenArray(data);
        this.divRendAnual.data = this.applyRendSort(this.divRendAnualRaw);
      }
     });
  }

  valoresPlanificador(){
    this.riesgosubscritpion = this._controlService.valRiesgo$.subscribe({
      next: (data: any)=>{
        const flattened = this.flattenArray(data);
        this.riesgo = flattened.length ? flattened : this.defaultRiesgo;
        console.log("Riesgo",this.riesgo);
      }
    });
    this.rentabilidadSub = this._controlService.valRentabilidad$.subscribe({
      next: (data: any)=>{
        const flattened = this.flattenArray(data);
        this.rentabilidad = flattened.length ? flattened : this.defaultRentabilidad;
        console.log("rentabilidad",this.rentabilidad);
      }
    });
     this.renAnualSub = this._controlService.valRendAnual$.subscribe({
      next: (data: any)=>{
        this.rendAnualRaw = this.flattenArray(data);
        this.rendAnual.data = this.applyRendSort(this.rendAnualRaw);
        console.log("rendimiento anual: ",this.rendAnual);
      }
     });
  }
  valoresGestor(){
    this.gestRentabilidadSub = this._gestorsv.valGestRentabilidad$.subscribe({
      next: (data: any)=>{
        const flattened = this.flattenArray(data);
        this.gestRentabilidad = flattened.length ? flattened : this.defaultRentabilidad;
      }
     });
     this.gestRiesgosubscritpion = this._gestorsv.valGestRiesgo$.subscribe({
      next: (data: any)=>{
        const flattened = this.flattenArray(data);
        this.gestRiesgo = flattened.length ? flattened : this.defaultRiesgo;
      }
     });
     this.gestRenAnualSub = this._gestorsv.valGestRendAnual$.subscribe({
      next: (data: any)=>{
        this.gestRendAnualRaw = this.flattenArray(data);
        this.gestRendAnual.data = this.applyRendSort(this.gestRendAnualRaw);
      }
     });

  }
  valoresBroker(){
    this.brokRentabilidadSub = this._brokersv.valBrokRentabilidad$.subscribe({
      next: (data: any)=>{
        const flattened = this.flattenArray(data);
        this.brokRentabilidad = flattened.length ? flattened : this.defaultRentabilidad;
      }
     });
     this.brokRiesgosubscritpion = this._brokersv.valBrokRiesgo$.subscribe({
      next: (data: any)=>{
        const flattened = this.flattenArray(data);
        this.brokRiesgo = flattened.length ? flattened : this.defaultRiesgo;
      }
     });
     this.brokRenAnualSub = this._brokersv.valBrokRendAnual$.subscribe({
      next: (data: any)=>{
        this.brokRendAnualRaw = this.flattenArray(data);
        this.brokRendAnual.data = this.applyRendSort(this.brokRendAnualRaw);
      }
     });

  }

}
